// @flow
export default (props) => {
	switch (props.decorator || props.is) {
		case 'EshopPhotogallery':
			// ESHOP: Produktova fotogalerie
			return import('fg-frontend/components/EshopPhotogallery');
		case 'EshopModel3D':
			// ESHOP: 3D model v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita 3D modelu (nastavitelne na fotogalerii))
			return import('fg-frontend/components/EshopModel3D');
		case 'EshopImageMagnify':
			// ESHOP: Lupa v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita lupy (nastavitelne na fotogalerii))
			return import('fg-frontend/components/EshopImageMagnify');
		case 'EshopGalleryPopup':
			// ESHOP: Podpora galerie v popupu (odeberte, pokud neni pozadovano chovani galerie v popupu)
			return import('fg-frontend/components/EshopGalleryPopup');
		case 'EshopOrderForm':
			// ESHOP: Podpurna komponenta pro vlozeni zbozi do kosiku (odeberte, pokud nemate v projektu nakupni proces)
			return import('fg-frontend/components/EshopOrderForm');
		case 'EshopFulltextAutocomplete':
			// ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
			return import('fg-frontend/src/components/EshopFulltextAutocomplete');
		case 'ProductListSlider':
		  return import('fg-frontend/components/ProductListSlider');
			// ESHOP: slider s produkty (odeberte, pokud neni v projektu zapnuta feature productProductRelation ani catalogRecentlyVisitedConfig v ramci catalogTracking feature)
		case 'EshopVariantStockHandler':
			// ESHOP: Komponenta pro osetreni vyberu variant v detailu produktu (odeberte, pokud neni na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>)
			return import('./components/EshopVariantStockHandler');
		case 'EshopUserToolsHandler':
			// ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani
			return import('./components/EshopUserToolsHandler');
		case 'EshopProductTile':
			// ESHOP: slouží pro pokročilé ovládání dlaždice produktu
			return import('./components/EshopProductTile');
		case 'RangeDatepicker':
			// COMMON: Komponenta intervaloveho datepickeru (odeberte, pokud nepouzivate Objednavky v B2B rezimu, nebo Faktury)
			return import('fg-frontend/components/RangeDatepicker');
		case 'BranchPicker':
			// ESHOP: vyber pobocky v ramci vybranych doprav - povolte, kdyz mate na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>
			return import('fg-frontend/src/components/BranchPicker');
    case 'CategoryFilter':
      // ESHOP: Filtr kategorií ve skupině produktů
      return import('./components/CategoryFilter');
    case 'GooglePayHandler':
      // ESHOP: Handler pro platbu GooglePay (odeberte, pokud neni v projektu CSOB Google Pay)
      return import('fg-frontend/src/components/GooglePayHandler');
    case 'ApplePayHandler':
      // ESHOP: Handler pro platbu ApplePay (odeberte, pokud neni v projektu CSOB Apple Pay)
      return import('fg-frontend/src/components/ApplePayHandler');
    case 'PaymentsFilter':
      // ESHOP: Vyfiltruje/schova nepouzitelne platby zavisle na browseru (ApplePay) (odeberte, pokud neni v projektu CSOB Apple Pay)
      return import('fg-frontend/src/components/PaymentsFilter');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js